<template>
  <div class="parent fullscreen">
    <el-dialog
      :visible.sync="zhuceDialog"
      width="330px"
      :show-close="false"
      class="zcDialog"
      top="35vh"
    >
      <div style="text-align:center">
        <span class="iconfont iconybapi2"></span>
        <span class="message">注册成功</span>
      </div>
    </el-dialog>

    <div class="login-content">
      <div style="position:relative;">
        <span class="iconfont iconybapi10"></span>
        <span class="login-span3">第三方对接平台</span>
        <span class="login-span4">企业注册</span>
        <img src="../assets/img/bg.jpg" style="width:100%;height:40.9%;" />
        <div class="zhuce" v-if="type==1">
          <!-- <div class="ad">
            <div class="ad-top">
              <span>此处为介绍平台对接的行业，优势等文字信息此处为介绍平台对接的行业，优势等文字信息此处为介绍平台对接的行业，优势等文字信息</span>
            </div>
            <div class="ad-mid">
              <span>现在申请可享为期一年的免费对接服务</span>
            </div>
            <div class="ad-bot">
              <el-row>
                <el-col :span="12">
                  <span style="padding-top:20px">一年期满后</span>
                </el-col>
                <el-col :span="12" class="txt-right">
                  <span>
                    <span style="font-size:26px">90</span>&nbsp;元/台/年
                  </span>
                </el-col>
              </el-row>
            </div>
          </div> -->
          <el-row>
            <el-col class="txt-right">
              <a style="color:#8F969F;font-size:14px;cursor:pointer;text-decoration:none" @click="gologin()">已有账户？立即去登录</a>
            </el-col>
          </el-row>
          <el-row style="padding:0px">
            <span class="login-span">注册账户</span>
          </el-row>
          <el-form :model="registerForm" :rules="rules" ref="registerForm">
            <el-row style="padding-top: 4px;">
              <el-col :span="19">
                <el-form-item prop="ucode" style="margin-bottom: 0;">
                  <el-input size="small" placeholder="手机号" class="login-input" v-model="registerForm.ucode"></el-input>
                  <el-button class="login-span6"  @click="sendMsg" type="primary" :disabled="isDisabled">{{buttonName}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="padding-top: 4px;">
              <el-col :span="10">
                <el-form-item style="margin-bottom: 0;" prop="code">
                  <el-input size="small" placeholder="验证码" v-model="registerForm.code"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="padding-top: 4px;">
              <el-col :span="19">
                <el-form-item prop="upass" style="margin-bottom: 0;">
                  <el-input show-password size="small" placeholder="密码" v-model="registerForm.upass"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="padding-top: 4px;">
              <el-col :span="19">
                <el-form-item prop="checkPass" style="margin-bottom: 0;">
                  <el-input show-password size="small" placeholder="重复密码" v-model="registerForm.checkPass"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="padding-top: 4px;">
              <el-col :span="19">
                <el-form-item prop="corp" style="margin-bottom: 0;">
                  <el-input size="small" placeholder="公司名称" class="login-input" v-model="registerForm.corp"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="padding-top: 8px;">
              <el-col :span="19">
                <el-form-item prop="addr" style="margin-bottom: 0;">
                  <el-input placeholder="公司地址" type="textarea" :rows="2" class="login-input" v-model="registerForm.addr"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="padding-top: 4px;">
              <el-col :span="19">
                <el-form-item prop="attn" style="margin-bottom: 0;">
                  <el-input size="small" placeholder="企业联系人" v-model="registerForm.attn"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="padding-top: 4px;">
              <el-col :span="19">
                <el-form-item prop="mail" style="margin-bottom: 0;">
                  <el-input size="small" placeholder="电子邮箱" v-model="registerForm.mail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="padding-top: 4px;">
              <el-col :span="19">
                <el-form-item prop="taxno" style="margin-bottom: 0;">
                  <el-input size="small" placeholder="税号" v-model="registerForm.taxno"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="txt-right" :span="22" style="padding-top:10px">
                <el-button
                  type="primary"
                  class="primarybtn"
                  style="width:114px;height:46px"
                  @click="register"
                >注册</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div class="bottominfo tobot">
      <label>Copyright@2020 南通易阳科技有限公司 保留所有权利</label>
      <!-- <span class="login-span2" @click="goadminlogin()">平台登录</span> -->
    </div>
  </div>
</template>

<script>
import util from "../components/util";
import Sidentify from "../components/Sidentify";
export default util.useCommon({
  name: "login",
  data() {
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else {
        if (/^[1][3,4,5,7,8][0-9]{9}$/.test(value) == false){
          callback(new Error('请输入正确的手机号'));
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,10}$/.test(value) == false){
          callback(new Error('请输入4~10位且包含字母数字的密码'));
        } else if(this.registerForm.checkPass !== '') {
          this.$refs.registerForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.registerForm.upass) {
        callback(new Error('密码不一致!'));
      } else {
        callback();
      }
    };
    var validatemail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱地址'));
      } else if (/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value) == false) {
        callback(new Error("请输入正确的邮箱地址"));
      } else {
        callback();
      }
    };
    var validateTaxno = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入税号'));
      } else if (/^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(value) == false) {
        callback(new Error("请输入正确的税号"));
      } else {
        callback();
      }
    };
    return {
      registerForm :{
        ucode : "",
        code : "",
        upass : "",
        checkPass : "",
        corp : "",
        addr : "",
        attn : "",
        mail : "",
        taxno : "",
      },
      buttonName: "获取验证码",
      isDisabled: false,
      time: 60,
      zhuceDialog: false,
      count: "",
      type: 1,
      interval: null,
      rules: {
        ucode: [
          { validator: validateCode, trigger: 'blur' },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        upass: [
          { validator: validatePass, trigger: 'blur' },
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' },
        ],
        corp: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          { max: 100, message: "长度不超过100个字符", trigger: "blur" },
        ],
        addr: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
          { max: 200, message: "长度不超过200个字符", trigger: "blur" },
        ],
        attn: [
          { required: true, message: "请输入企业联系人", trigger: "blur" },
          { max: 20, message: "长度不超过20个字符", trigger: "blur" },
        ],
        mail: [
          { validator: validatemail, trigger: "blur" }
        ],
        taxno: [
          { validator: validateTaxno, trigger: "blur" },
          { max: 20, message: "长度不超过20个字符", trigger: "blur" },
        ],
      }
    };
  },
  components: {},
  mounted() {},
  activated() {
    var v = this;
    v.registerForm = {
        ucode : "",
        code : "",
        upass : "",
        checkPass : "",
        corp : "",
        addr : "",
        attn : "",
        mail : "",
        taxno : "",
    };
    v.buttonName = "获取验证码";
    v.isDisabled = false;
    v.time = 60;
    v.zhuceDialog = false;
    v.count = "";
    v.type =  1;
    v.destroyed();
    v.$refs["registerForm"].resetFields();
  },
  methods: {
    destroyed(){
        if(this.interval) { //如果定时器在运行则关闭
            clearInterval(this.interval); 
        }
    },
    sendMsg() {
      var v = this;
      v.isDisabled = true;
      var checkMsg = [];
      if (!v.registerForm.ucode){
        checkMsg.push("请输入手机号");
      } else if (/^[1][3,4,5,7,8][0-9]{9}$/.test(v.registerForm.ucode) == false){
        checkMsg.push("请输入正确的手机号");
      }

      if(checkMsg.length>0){
        v.isDisabled = false;
        v.message("error", checkMsg.join("<br/>"));
        return;
      }
      v.dopost("/clogin/getVcode",{ucode:v.registerForm.ucode,mode :1},
        function(result) {
          if ("0000" === result.state) {
            v.isDisabled = true;
            v.interval = window.setInterval(function() {
              v.buttonName = '（' + v.time + '秒）后重新发送';
              --v.time;
              if(v.time < 0) {
                v.buttonName = "重新发送";
                v.time = 60;
                v.isDisabled = false;
                clearInterval(v.interval);
              }
            }, 1000);
          } else if ("1000" === result.state) {
            var msg = [];
            for (var i = 0; i < result.body.length; i++) {
              msg.push(result.body[i].errmsg);
            }
            v.isDisabled = false;
            v.message("error", msg.join("<br/>"));
          }
          console.log(result);
        }
      );
    },
    gologin() {
      var v = this;
      v.$router.replace("/");
    },
    goadminlogin(){
      var v = this;
      v.$router.replace("/adLogin");
    },
    register() {
      var v = this;
      v.$refs['registerForm'].validate(valid => {
        if (valid) {
          v.confirm("确定注册?", function(isOk) {
            if (isOk) {
              v.dopost("/clogin/register", v.registerForm, function(result) {
                if("0000" === result.state){
                  v.message("success", "注册成功！");
                  // 跳转页面
                  v.$router.replace("/");
                  v.$refs["registerForm"].resetFields();
                }else{
                  var msg =[];
                  for(var i=0;i<result.body.length;i++){
                    msg.push(result.body[i].errmsg);
                  }
                  v.message("error", msg.join("<br/>"));
                }
                console.log(result);
              });
            }
          });
        }else {
          return false;
        }
      });
    },
  }
});
</script>
<style  scoped>
.login-span6 {
  width: 160px;
  padding: 0 20px;
  height:80%;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #ffffff;
  font-size: 13px;
}
.banquan {
  background-color: green;
  height: 40px;
}
.ad {
  color: #ffffff;
  position: absolute;
  top: 0px;
  left: -276px;
}
.bottominfo {
  position: relative;
}
.ad-top {
  width: 260px;
  height: 187px;
  background-color: #6d8efc;
  border-radius: 10px;
  padding: 31px 17px 35px 25px;
}
.ad-mid {
  width: 260px;
  height: 91px;
  background-color: #f9b144;
  border-radius: 10px;
  position: relative;
  top: -18px;
  padding: 19px 39px 22px 39px;
  text-align: center;
}
.ad-bot {
  width: 260px;
  height: 76px;
  background-color: #8295ae;
  border-radius: 10px;
  position: relative;
  top: -31px;
  padding: 19px 17px 0px 21px;
}

.login-span {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.el-row {
  padding: 10px 0px;
}
.tips-p {
  padding-left: 13px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  word-break: break-all;
  margin-bottom: 0px;
}
.tips-p1 {
  padding-left: 13px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  word-break: break-all;
  margin-bottom: 0px;
  line-height: 32px;
}
.login-span2 {
  position: absolute;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  top: -50px;
}
@media screen and (min-width: 1366px) {
  .zhuce {
    position: absolute;
    top: 240px;
    left: 50%;
    transform: translateX(-50%);
    width: 628px;
    height: 670px;
    box-shadow: 0px 0px 6px rgba(57, 58, 68, 0.25);
    background-color: #ffffff;
    border-radius: 10px;
    padding: 14px 33px 0px 92px;
  }
  .audit {
    position: relative;
    top: -100px;
    left: 50%;
    transform: translateX(-30%);
    width: 628px;
    height: 490px;
    box-shadow: 0px 0px 6px rgba(57, 58, 68, 0.25);
    background-color: #ffffff;
    border-radius: 10px;
    padding: 14px 33px 0px 92px;
    display: block;
  }
  .login-content {
    height: calc(100% - 40px);
  }
  .iconybapi10 {
    position: absolute;
    color: #ffffff;
    left: 178px;
    top: 40px;
    font-size: 40px;
  }

  .login-span3 {
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
  }
  .login-span4 {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    position: absolute;
    top: 180px;
    left: 50%;
    transform: translateX(-50%);
    padding: 3px 20px;
    background-color: #5f75e3;
    border-radius: 18px;
    border: #7e92f6 1px solid;
  }
}
@media screen and (max-width: 1600px) {
  .zhuce {
    position: absolute;
    top: 140px;
    left: 50%;
    transform: translateX(-50%);
    width: 628px;
    height: 690px;
    box-shadow: 0px 0px 6px rgba(57, 58, 68, 0.25);
    background-color: #ffffff;
    border-radius: 10px;
    padding: 14px 33px 0px 92px;
  }
  .iconybapi10 {
    position: absolute;
    color: #ffffff;
    left: 178px;
    top: 10px;
    font-size: 40px;
  }
  .login-content {
    height: auto;
  }
  .audit {
    position: relative;
    top: -120px;
    left: 50%;
    transform: translateX(-30%);
    width: 628px;
    height: 490px;
    box-shadow: 0px 0px 6px rgba(57, 58, 68, 0.25);
    background-color: #ffffff;
    border-radius: 10px;
    padding: 14px 33px 0px 92px;
  }
  .login-span3 {
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  .login-span4 {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    padding: 3px 20px;
    background-color: #5f75e3;
    border-radius: 18px;
    border: #7e92f6 1px solid;
  }
  .tobot {
    bottom: -618px;
  }
}

.iconybapi2 {
  font-size: 42px;
  color: #547cff;
}
.message {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  position: relative;
  top: -10px;
  padding-left: 10px;
}
.zcDialog /deep/ .el-dialog__body {
  padding: 0px 20px 30px 20px;
}
.login-content /deep/ .el-form-item__error{
    padding-top: 0px;
    color: #ff8456;
}
</style>